import {get, set, del} from 'idb-keyval';

export class CsIndexedDbJsHelper {
  public async getValueByKey(key: string): Promise<string | null> {
    const value = await get(key);
    return value || null;
  }

  public async setValueByKey(key: string, value: string): Promise<void> {
    await set(key, value);
    // Update window global variable if updateGlobalVariables exists
    if (typeof (window as any).updateGlobalVariables === 'function') {
      (window as any).updateGlobalVariables(key, value);
    }
  }

  public async deleteValueByKey(key: string): Promise<void> {
    await del(key);
    // Update window global variable if updateGlobalVariables exists
    if (typeof (window as any).updateGlobalVariables === 'function') {
      (window as any).updateGlobalVariables(key, null);
    }
  }
}
